import React, { useState } from "react";
import api from "../lib/api";

export default function PharmacyOnboarding({ branchId, data, canConfirm, onConfirmed }) {
  const [payment, setPayment] = useState(false); const [invoice, setInvoice] = useState(false);
  const [error, setError] = useState(""); const [busy, setBusy] = useState(false);
  if (!data) return null;
  const completed = data.steps.find(s => s.id === "collection_invoice")?.done;
  const confirm = async () => {
    setBusy(true);
    try { await api.post(`/v1/pharmacy/manage/${branchId}/onboarding`, { manual_payment_process: payment, invoice_process: invoice }); await onConfirmed(); }
    catch (e) { setError(e?.response?.data?.detail || "Unable to save onboarding confirmation."); }
    setBusy(false);
  };
  return <section className="mg-card mb-5"><h2 className="font-bold">Pharmacy launch setup · {data.completed}/{data.total}</h2>
    <ul className="text-sm space-y-1 mt-3">{data.steps.map(step => <li key={step.id}>{step.done ? "✓" : "○"} {step.title}</li>)}</ul>
    <p className="text-sm mt-3">{data.payment_note}</p>
    {canConfirm && !completed && <div className="space-y-2 mt-3">
      <label className="block text-sm"><input type="checkbox" checked={payment} onChange={e => setPayment(e.target.checked)} /> Our team checks received payment before marking an order paid.</label>
      <label className="block text-sm"><input type="checkbox" checked={invoice} onChange={e => setInvoice(e.target.checked)} /> Our team knows how to provide and attach the pharmacy invoice for a paid order.</label>
      {error && <p role="alert" className="text-red-700">{error}</p>}
      <button className="mg-btn-primary" disabled={busy || !payment || !invoice} onClick={confirm}>Confirm team setup</button>
    </div>}
  </section>;
}
